import React from 'react';

interface CopyContentProps {
  replyData: any;
  setShowCopyText: (show: boolean) => void;
}

const handleCopy = (replyData: any, setShowCopyText: (show: boolean) => void, someResposeId: string) => {
  setTimeout(() => {
    const textContainer = document.querySelector(`.resCopy${someResposeId}`) as HTMLElement | null;
    const allTableData = replyData?.relevantFiles || [];

    if (!textContainer) {
      console.error("Content not found!");
      return;
    }
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute"; 
    tempDiv.style.left = "-9999px";

    const summaryClone = textContainer.cloneNode(true) as HTMLElement;
    tempDiv.appendChild(summaryClone);

    if (allTableData.length > 0) {
    const tempTable = document.createElement("table");
    tempTable.style.border = "1px solid black";
    tempTable.style.borderCollapse = "collapse";

    const headerRow = document.createElement("tr");
    ["Document Title", "Page nos.", "Source"].forEach((header) => {
      const th = document.createElement("th");
      th.textContent = header;
      th.style.border = "1px solid black";
      th.style.padding = "5px";
      th.style.background = "#fff";
      th.style.color = "#000";
      headerRow.appendChild(th);
    });
    tempTable.appendChild(headerRow);

    allTableData.forEach((row: any) => {
      const tr = document.createElement("tr");

      [row.file_name, row.page_number, row.source].forEach((cellData) => {
        const td = document.createElement("td");
        td.textContent = cellData;
        td.style.border = "1px solid black";
        td.style.padding = "5px";
        td.style.background = "#fff";
        td.style.color = "#000";
        tr.appendChild(td);
      });

      tempTable.appendChild(tr);
    });
    tempDiv.appendChild(tempTable);
  }
    document.body.appendChild(tempDiv);
    const range = document.createRange();
    range.selectNodeContents(tempDiv);
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    document.execCommand("copy");
    selection?.removeAllRanges();
    document.body.removeChild(tempDiv);

    setShowCopyText(true);
    setTimeout(() => {
      setShowCopyText(false);
    }, 1000);
  }, 500);
};

const CopyContent: React.FC<CopyContentProps> = ({ replyData, setShowCopyText }) => {
  return null;
};

export { handleCopy, CopyContent };
export type { CopyContentProps };
export default CopyContent;